import {Button} from '@wandb/components';
import {
  Content,
  Overlay,
  Portal,
  Root,
  Title,
} from '@wandb/weave/components/Dialog/Dialog';
import React from 'react';

import {ArtifactVersionMetricsPanelView} from './ArtifactVersionMetricsPanelView';
import {type ArtifactVersionMetricGridPanel} from './artifactVersionsGridTypes';
import {INITIAL_CONFIG} from './types';

type ArtifactVersionMetricFullscreenModalProps = {
  artifactCollectionId?: string;
  currentIndex: number;
  membershipIds: string[];
  onClose: () => void;
  onNext: () => void;
  onPrevious: () => void;
  panel: ArtifactVersionMetricGridPanel;
  panelCount: number;
};

export const ArtifactVersionMetricFullscreenModal: React.FC<
  ArtifactVersionMetricFullscreenModalProps
> = ({
  artifactCollectionId,
  currentIndex,
  membershipIds,
  onClose,
  onNext,
  onPrevious,
  panel,
  panelCount,
}) => {
  const config = {
    ...INITIAL_CONFIG,
    ...panel.config,
    membershipIds,
  };
  const artifactVersionMetadata = {
    membershipIds,
    totalMemberships: membershipIds.length,
    loading: false,
  };
  const handleOpenChange = (open: boolean) => {
    if (!open) {
      onClose();
    }
  };
  const isFirstPanel = currentIndex <= 0;
  const isLastPanel = currentIndex >= panelCount - 1;

  return (
    <Root open onOpenChange={handleOpenChange}>
      <Portal>
        <Overlay />
        <Content
          // This is a modal so it is a valid usecase for calc
          // oxlint-disable-next-line wandb/no-calc-100vh-pixel-math
          className="flex aspect-[49/30] w-[min(calc((100vh-128px)*49/30),calc(100vw-64px),980px)] flex-col overflow-hidden rounded-lg p-0"
          data-test="artifact-version-metrics-fullscreen-modal">
          <Title className="sr-only">Artifact version metrics</Title>
          <div className="min-h-0 flex-1 overflow-hidden bg-wb-surface p-16">
            <ArtifactVersionMetricsPanelView
              artifactCollectionId={artifactCollectionId}
              artifactVersionMetadata={artifactVersionMetadata}
              config={config}
              variant="fullscreen"
            />
          </div>
          <div className="flex shrink-0 items-center justify-between gap-12 border-t border-solid border-wb-border bg-wb-surface-sunken px-16 py-12">
            <div className="flex items-center gap-8">
              <Button
                isDisabled={isFirstPanel}
                variant="secondary"
                onPress={onPrevious}>
                Previous
              </Button>
              <Button
                isDisabled={isLastPanel}
                variant="secondary"
                onPress={onNext}>
                Next
              </Button>
            </div>
            <Button variant="secondary" onPress={onClose}>
              Close
            </Button>
          </div>
        </Content>
      </Portal>
    </Root>
  );
};
